import React, { useEffect, useState } from 'react'

import { useParams } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'

import {  showShifts, updateShifts } from '../../../../MyApi/sb/shifts'


import PageHeader from '../../../../Components/UI/PageHeader'
import EditShift from '../../../../Components/sb/shifts/shiftsUpdate/AddShift'
import LoadingSpinner from '../../../../Components/UI/spinner'




const ShiftsUpdate = () => {
const [shiftName ,setshiftName]= useState("")
const [companyId ,setCompanyId]= useState("")
const [active ,setActive] =useState(1)
const [flexible ,setFlexible] =useState(1)
const [breakTime ,setBreakTime] =useState(1)

const initialWeekData = [
   { day: "Saturday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Sunday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null ,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0},
   { day: "Monday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0},
   { day: "Tuesday", start_time: null, end_time: null, start_checkin: null, end_checkin: null, start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Wednesday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null, flexible: 0, break: 1, day_off: 0},
   { day: "Thursday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
   { day: "Friday", start_time: null, end_time: null, start_checkin: null, end_checkin: null,start_break:null,end_break:null, start_checkout: null, end_checkout: null, flexible_hours: null,  flexible: 0, break: 1, day_off: 0 },
 ];
 const [weeksData, setWeekData] = useState(initialWeekData);
 let  lang = localStorage.getItem("i18nextLng")
 const [selectedCodeLang ,setSelectedCodeLang]=useState(lang)
 const {id}= useParams()
 const  {data ,isLoading }= useQuery(['showshifts',id],()=> showShifts(id))
 const mutation = useMutation(["updateShifts",id ,selectedCodeLang] , (postData )=>updateShifts(postData,id ,selectedCodeLang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
       
    },
    onError :(error)=>{
       toast.error(`${error.response.data.message}`)
    }
 })

const shifts = data?.data ||[]


 useEffect(()=>{
   setshiftName(shifts.name)
   setWeekData(shifts.days || [])
   setActive(shifts.active)
   setFlexible(shifts.flexible)
   setCompanyId(shifts.sb_company_id)
   setBreakTime(shifts.break)
 },[shifts])

 const handlePostRequest =()=>{
    mutation.mutate({
        name:shiftName,     
        sb_company_id:+companyId,
        flexible,
        break:breakTime,
        active,
        days:weeksData,
        lang_code:selectedCodeLang
    })
 }
 const isDisabled= ()=>{
   return !(shiftName && companyId )
 }
 const onSelectChange =(e)=>{
   setSelectedCodeLang(e.target.value)
 }
 if(isLoading){
   return <LoadingSpinner/>
 }
 if(!data){
   return <div>no data avalible</div>
 }
  return ( 

    <div>
        <PageHeader title="Edit shift" showSelect onSelectChange={onSelectChange}  showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
  
        <EditShift shiftName={shiftName} companyId={companyId}  setCompanyId={setCompanyId} setshiftName={setshiftName}    setActive={setActive} setFlexible={setFlexible} setBreakTime={setBreakTime}  active={active} flexible={flexible} breakTime={breakTime} setWeekData={setWeekData} weeksData={weeksData}  />
    </div>
  )
}

export default ShiftsUpdate